/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const CompanyIdMin = 2;
export const CompanyIdMax = 50;

export const CompanyIdRegExp = new RegExp(".*\\S.*");

export const CompanyId = zod
  .string()
  .min(CompanyIdMin)
  .max(CompanyIdMax)
  .regex(CompanyIdRegExp)
  .describe("Company identifier normalized by the Business Foundation policy.");

export type CompanyId = zod.input<typeof CompanyId>;
export type CompanyIdOutput = zod.output<typeof CompanyId>;
